import { GraphQLError } from 'graphql';

export interface NetworkError {
  statusCode?: number;
  status?: number;
  networkError?: { statusCode?: number };
}

export const isAuthError = (
  graphQLErrors: readonly GraphQLError[] | undefined, 
  networkError: unknown
): boolean => {
  const graphqlAuth = graphQLErrors?.some((err) => 
    err.extensions?.code === 'UNAUTHENTICATED' || 
    err.extensions?.code === 'AUTHENTICATION_ERROR' ||
    err.message?.includes('Invalid user token')
  );

  const networkAuth = networkError && typeof networkError === 'object' && (
    'statusCode' in networkError && (networkError as NetworkError).statusCode === 401 ||
    'status' in networkError && (networkError as NetworkError).status === 401
  );

  return !!(graphqlAuth || networkAuth);
};
